import { useContext } from 'react';
import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk';

import { InternalContext } from '@/shared/contexts/launch-darkly/InternalContext';

type BooleanOrUndefined = boolean | undefined;

type Flags = {
  autoopsShowSearchTierPage: BooleanOrUndefined;
  autoopsShowIndexingTierPage: BooleanOrUndefined;
  opexDataRetentionRange: number | undefined;
  opexFeedbackTourConfig:
    | { firstShowDay?: number; secondShowDay?: number; showTour?: boolean }
    | undefined;
  /** Narrows AutoOps Cloud assistant access when config IS_CLOUD_ASSISTANT_ENABLED is on. */
  autoopsCloudAssistant: BooleanOrUndefined;
};

export const useFlags = () => {
  const { status } = useContext(InternalContext);
  const flags: Flags = useLaunchDarklyFlags();

  return { status, flags };
};
